module.exports = __webpack_public_path__ + "img/e24cc67.png";